let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("51fo4")).then(() => parcelRequire('e1e78'));